var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
let StoryPathCard = class StoryPathCard extends Vue {
};
__decorate([
    Prop()
], StoryPathCard.prototype, "cssClass", void 0);
__decorate([
    Prop()
], StoryPathCard.prototype, "sectors", void 0);
__decorate([
    Prop()
], StoryPathCard.prototype, "id", void 0);
__decorate([
    Prop()
], StoryPathCard.prototype, "url", void 0);
__decorate([
    Prop()
], StoryPathCard.prototype, "title", void 0);
__decorate([
    Prop()
], StoryPathCard.prototype, "textIntro", void 0);
__decorate([
    Prop()
], StoryPathCard.prototype, "partnerTag", void 0);
__decorate([
    Prop()
], StoryPathCard.prototype, "tagline", void 0);
__decorate([
    Prop()
], StoryPathCard.prototype, "imageUrl", void 0);
__decorate([
    Prop()
], StoryPathCard.prototype, "imageAlt", void 0);
__decorate([
    Prop()
], StoryPathCard.prototype, "currentPage", void 0);
__decorate([
    Prop()
], StoryPathCard.prototype, "activeSectorId", void 0);
__decorate([
    Prop()
], StoryPathCard.prototype, "labels", void 0);
StoryPathCard = __decorate([
    Component
], StoryPathCard);
export default StoryPathCard;
